import { Card, CardContent, Typography, Box, Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';
import NoRecords from 'components/NoRecords';

const MonthStanding = ({ months }) => {
    const { t } = useTranslation();

    const getScoreColor = (score) => {
        if (score > 0) return 'success.main';
        if (score < 0) return 'error.main';
        return 'text.secondary';
    };

    return (
        <Card variant="outlined" sx={{ borderRadius: 2 }}>
            <CardContent>
                <Box height={55} display={'flex'} alignItems={'center'}>
                    <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                        {t("This Month's Points")}
                    </Typography>
                </Box>
                <Divider sx={{ mb: 2 }} />
                {months?.length > 0 ? (
                    months.map((month, index) => (
                        <Box key={index} sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
                            <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.secondary', textTransform: 'uppercase' }}>
                                {month.label}
                            </Typography>
                            <Typography variant="body2" sx={{ fontWeight: 'bold', color: getScoreColor(month.score) }}>
                                {month.score > 0 ? `+ ${month.score}` : month.score}
                            </Typography>
                        </Box>
                    ))

                ) : (
                    <NoRecords message={t('No Month data available.')} variant='body2' />
                )}
            </CardContent>
        </Card>
    );
};

export default MonthStanding;